import { observer } from 'mobx-react-lite';
import * as React from 'react';

import SearchSortedItemsTransition from '@/components/shared/searchTree/SearchSortedItemsTransition/SearchSortedItemsTransition';
import { useSidebarDocumentsStore } from '@/stores/local/sidebar/SidebarDocumentsStore';

import SearchItem from './SearchItem';

import s from './SearchItems.module.scss';

type SearchItemsProps = {
  withSelection?: boolean;
};

const SearchItems: React.FC<SearchItemsProps> = ({ withSelection = false }) => {
  const {
    searchDocumentStore: { collection, sortBy },
  } = useSidebarDocumentsStore();

  return (
    <SearchSortedItemsTransition items={collection.items} sortBy={sortBy} className={s.root}>
      {(sortedItems) =>
        sortedItems.map((item) => <SearchItem key={item.searchResultId} item={item} withSelection={withSelection} />)
      }
    </SearchSortedItemsTransition>
  );
};

export default observer(SearchItems);
